import { Component } from '@angular/core';
import { BaseInputFieldComponent } from '../base/base-input-field.component';

@Component({
  selector: 'shared-ui-inputs-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.css',
  standalone: false,
})
export class ToggleSwitchComponent extends BaseInputFieldComponent {
  constructor() {
    super();
  }
}
